import { SpecialOfferState } from '@/types/store'
import { GetSpecialOfferResponse } from '../../../api/@types'
import { MutationTree } from 'vuex'

export const mutations: MutationTree<SpecialOfferState> = {
  setIsSpecialOfferLoading(state, isLoading: boolean) {
    state.isSpecialOfferLoading = isLoading
  },
  specialOfferLoaded(state, specialOffers: GetSpecialOfferResponse[]) {
    state.specialOffers = specialOffers
  },
  setSpecialOffer(state, specialOffer: GetSpecialOfferResponse) {
    state.specialOffer = specialOffer
  },
}
